import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrWifiIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M9.1246 13.0791C9.1246 13.5907 8.71565 14 8.20447 14C7.69329 14 7.28434 13.5907 7.28434 13.0791C7.28434 12.5674 7.69329 12.1581 8.20447 12.1581C8.71565 12.1581 9.1246 12.5674 9.1246 13.0791ZM4.31949 10.3163C4.01278 10.6233 4.01278 11.0326 4.31949 11.3395C4.6262 11.6465 5.03514 11.6465 5.34185 11.3395C6.77316 9.90698 9.22684 9.90698 10.6581 11.3395C10.9649 11.6465 11.3738 11.6465 11.6805 11.3395C11.9872 11.0326 11.9872 10.6233 11.6805 10.3163C9.63578 8.37209 6.36422 8.37209 4.31949 10.3163ZM2.27476 8.26977C1.96805 8.57674 1.96805 8.98605 2.27476 9.29302C2.58147 9.6 2.99042 9.6 3.29712 9.29302C5.85303 6.73488 10.147 6.73488 12.7029 9.29302C13.0096 9.6 13.4185 9.6 13.7252 9.29302C14.0319 8.98605 14.0319 8.57674 13.7252 8.26977C10.5559 5.09767 5.44409 5.09767 2.27476 8.26977ZM15.77 6.22326C11.476 1.92558 4.52396 1.92558 0.230032 6.22326C-0.0766773 6.53023 -0.0766773 6.93953 0.230032 7.24651C0.536741 7.55349 0.945687 7.55349 1.2524 7.24651C4.93291 3.56279 11.0671 3.56279 14.7476 7.24651C15.0543 7.55349 15.4633 7.55349 15.77 7.24651C16.0767 6.93953 16.0767 6.53023 15.77 6.22326Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrWifiIconComponent;
